import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useBreakpointValue,
  Flex,
  Text,
  Divider,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import { useContext, useState } from "react";
import { appRequest } from "routes";
import HeadingSS from "../common/Heading/HeadingSS";
import WorkflowListComponent from "components/common/WorkflowListComponent/WorkflowListComponent";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  menu: boolean;
};

export default function WorkflowListModal({
  isOpen,
  onClose,
  menu,
}: ModalProps): JSX.Element {
  const { toastNotify, setDefaultAbsent, getDefaultWorkFlow, setWorkflowProcess, workflowProcess } =
    useContext(AppContext);

  const [defaultLoading, setDefaultLoading] = useState(false);
  const modalSize = useBreakpointValue({ base: "xs", md: "xl" });

  // ✅ Update workflow status handler
  const changeWorkFlowStatus = async (id: any, status: boolean) => {
    try {
      setDefaultLoading(true);
      const response: any = await appRequest("workflow", "updateStatus", {
        id,
        status
      });

      if (response.status === "success") {
        toastNotify({
          title: "Status updated successfully",
          message: response?.message,
          type: "success",
        });

        // refresh workflow after a short delay
        setTimeout(() => {
          getDefaultWorkFlow();
        }, 1500);

        onClose();
      } else {
        toastNotify({
          title: "Failed to Update Status",
          message: response?.message || "Something went wrong.",
          type: "error",
        });
      }
    } catch (err: any) {
      toastNotify({
        title: "Failed to Update Status",
        message: err?.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setDefaultLoading(false);
      setDefaultAbsent(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={modalSize}
      // isCentered
      scrollBehavior="inside"
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent
        borderRadius="2xl"
        shadow="2xl"
        overflow="hidden"
        bg="white"
        minW="80vw"
      >
        {/* Header */}
        <ModalHeader
          py={4}
          px={6}
          borderBottomWidth="1px"
          bg="gray.50"
          position="sticky"
          top={0}
          zIndex={1}
        >
          <Flex align="center" justify="space-between" alignItems="center">
            <HeadingSS fontSize="xl" headingSS="Select Workflow" />
            {true && (
              <ModalCloseButton
                top="12px"
                right="12px"
                borderRadius="full"
                bg="red.500"
                _hover={{ bg: "red.500", transform: "scale(1.1)" }}
                _active={{ bg: "gray.300" }}
                boxShadow="sm"
                color="white"
              />
            )}
          </Flex>
        </ModalHeader>

        {/* Body */}
        <ModalBody px={6} py={4}>
          <Text fontSize="sm" color="gray.500" mb={3} display="none">
            Choose from your available workflows below and set one as default.
          </Text>

          <Divider mb={4} />

          <WorkflowListComponent onClose={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}